import { render, staticRenderFns } from "./documentPreviewDialog.vue?vue&type=template&id=512c89aa&scoped=true"
import script from "./documentPreviewDialog.vue?vue&type=script&lang=js"
export * from "./documentPreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./documentPreviewDialog.vue?vue&type=style&index=0&id=512c89aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512c89aa",
  null
  
)

export default component.exports